const checkProps = ({ key = '', listOfKey = [], defaultReturn }) => {
  const searchKey = listOfKey?.find((items) => items?.toLowerCase() === key?.toLowerCase());

  return searchKey?.toLowerCase() ?? defaultReturn ?? null;
};

export default checkProps;
